import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import Person from '@material-ui/icons/Person';
import Settings from '@material-ui/icons/Settings';

function UserAccountModal({
  userModel,
  showUserModel,
  navUser,
  handleSignOut,
}) {
  return (
    <div className='absolute top-0 right-0'>
      {!userModel ? (
        <div className='hidden md:flex md:justify-end pr-20 -mt-8 relative z-40'>
          <div
            ref={navUser}
            className='md:w-56 md:h-40 md:bg-white border-2 shadow-md rounded-lg absolute mt-32'
          >
            <div className='flex justify-end pt-4 '>
              <RouterLink
                onClick={showUserModel}
                to='/activites'
                className='text-xs text-gray-600 px-2 pt-2 cursor-pointer'
              >
                الحساب الشخصي
              </RouterLink>
              <Person
                alt='person'
                className='sm:w-8 w-8 mr-10'
                style={{ color: 'black' }}
              />
            </div>
            <div className='flex justify-end pt-4'>
              <RouterLink
                onClick={showUserModel}
                to='/profile'
                className='text-xs text-gray-600 px-2 pt-1 cursor-pointer'
              >
                الإعدادات
              </RouterLink>
              <Settings
                alt='setting'
                className='w-6 h-6 mr-10 ml-1'
                style={{ color: 'black' }}
              />
            </div>
            <div className='flex justify-center py-4'>
              <button
                onClick={handleSignOut}
                className='blue-bg border text-white text-xs rounded-full w-24 h-8 focus:outline-none'
              >
                تسجيل الخروج
              </button>
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
}

export default UserAccountModal;
